// @flow
import React from 'react';

export default React.createContext('map');



// WEBPACK FOOTER //
// ./components/Map/MapContext.js